import {
  LOAD_DAY_MENU_COMPLETE,
  LOAD_DAY_MENU_ERROR,
  LOAD_WEEKLY_MENU,
  LOAD_WEEKLY_MENU_COMPLETE,
  LOAD_WEEKLY_MENU_ERROR
} from '../constants/actionTypes';
import { getDayMenu, getWeeklyMenu } from '../utils/apiMenu';

export const loadDayMenuComplete = response => ({
  type: LOAD_DAY_MENU_COMPLETE,
  menu: response,
  id: response.menuDate
});

export const loadWeeklyMenuComplete = ({
  menus,
  allergensUrl,
  wellnessMenuUrl
}) => ({
  type: LOAD_WEEKLY_MENU_COMPLETE,
  menus,
  allergensUrl,
  wellnessMenuUrl
});

export const loadDayMenuError = {
  type: LOAD_DAY_MENU_ERROR
};

export const loadWeeklyMenuError = {
  type: LOAD_WEEKLY_MENU_ERROR
};

export const loadDayMenu = () => dispatch =>
  getDayMenu()
    .then(response => dispatch(loadDayMenuComplete(response)))
    .catch(() => dispatch(loadDayMenuError));

export const loadWeeklyMenu = () => dispatch => {
  dispatch({ type: LOAD_WEEKLY_MENU });
  getWeeklyMenu()
    .then(response => dispatch(loadWeeklyMenuComplete(response)))
    .catch(() => dispatch(loadWeeklyMenuError));
};
